<template>
    <div class="box">
        <div class="null-page" v-show="yes"></div>

        <el-card class="point-exchange-order" shadow="never" v-loading="loading">
            <div class="page-header">
                <div>
                    <span class="page-title">兑换记录</span>
                    <span class="page-desc">查看积分商城兑换订单、物流与支付状态</span>
                </div>
                <el-button size="small" icon="el-icon-refresh" @click="refresh">刷新</el-button>
            </div>

            <div class="summary-row">
                <div class="summary-item">
                    <span>全部记录</span>
                    <strong>{{ total }}</strong>
                </div>
                <div class="summary-item">
                    <span>待支付</span>
                    <strong>{{ waitPayCount }}</strong>
                </div>
                <div class="summary-item">
                    <span>当前页消耗积分</span>
                    <strong>{{ currentPagePoint }}</strong>
                </div>
            </div>

            <el-table :data="orderList" class="record-table" empty-text="暂无积分兑换数据">
                <el-table-column label="兑换商品" min-width="260">
                    <template slot-scope="scope">
                        <div class="goods-cell">
                            <el-image class="goods-image" :src="getExchangeImage(scope.row)" fit="cover">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                            <div class="goods-info">
                                <div class="goods-name">{{ scope.row.exchange_name || "暂无名称" }}</div>
                                <div class="goods-meta">
                                    <span>订单号：{{ scope.row.order_no || "--" }}</span>
                                    <span>数量：x{{ scope.row.num || 0 }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="兑换类型" width="110" align="center" header-align="center">
                    <template slot-scope="scope">
                        <el-tag size="mini" effect="plain">{{ exchangeTypeName(scope.row.type) }}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="消耗积分" width="120" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span class="point-value">-{{ scope.row.point || 0 }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="支付金额" width="120" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span>￥{{ money(scope.row.price) }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="statusTagType(scope.row.order_status)" size="mini">
                            {{ statusName(scope.row.order_status) }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="物流信息" min-width="210">
                    <template slot-scope="scope">
                        <div v-if="hasLogisticsInfo(scope.row)" class="logistics-cell">
                            <div>{{ logisticsName(scope.row) }}</div>
                            <div v-if="scope.row.delivery_no" class="delivery-no">
                                <span>{{ scope.row.delivery_no }}</span>
                                <el-button type="text" size="mini" @click="copyDeliveryNo(scope.row.delivery_no)">复制</el-button>
                            </div>
                        </div>
                        <span v-else class="muted">暂无物流</span>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="150" align="right">
                    <template slot-scope="scope">
                        <template v-if="scope.row.order_status == 0 && scope.row.type == 1">
                            <el-button size="mini" @click="orderClose(scope.row)">关闭</el-button>
                            <el-button size="mini" type="primary" @click="goPay(scope.row)">支付</el-button>
                        </template>
                        <span v-else class="muted">--</span>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pager">
                <el-pagination
                    background
                    :pager-count="5"
                    :total="total"
                    prev-text="上一页"
                    next-text="下一页"
                    :current-page.sync="currentPage"
                    :page-size.sync="pageSize"
                    @size-change="handlePageSizeChange"
                    @current-change="handleCurrentPageChange"
                    hide-on-single-page
                ></el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { pointExchangeOrderPage, closePointExchangeOrder } from "@/api/member/point_exchange_order"

export default {
    name: "point_exchange_order",
    data: () => {
        return {
            orderList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            loading: true,
            yes: true
        }
    },
    computed: {
        ...mapGetters(["defaultGoodsImage", "addonIsExit"]),
        waitPayCount() {
            return this.orderList.filter(item => item.order_status == 0).length
        },
        currentPagePoint() {
            return this.orderList.reduce((sum, item) => sum + Number(item.point || 0), 0)
        }
    },
    created() {
        if (this.addonIsExit && this.addonIsExit.pointexchange != 1) {
            this.$message({
                message: "积分商城插件未安装或未开启",
                type: "warning",
                duration: 2000,
                onClose: () => {
                    this.$router.push("/member/index")
                }
            })
            this.loading = false
            return
        }
        this.getListData()
    },
    mounted() {
        setTimeout(() => {
            this.yes = false
        }, 300)
    },
    methods: {
        getListData() {
            this.loading = true
            pointExchangeOrderPage({
                page: this.currentPage,
                page_size: this.pageSize
            })
                .then(res => {
                    if (res.code == 0 && res.data) {
                        this.orderList = res.data.list || []
                        this.total = res.data.count || 0
                    } else {
                        this.orderList = []
                        this.total = 0
                        this.$message.warning(res.message || "兑换记录获取失败")
                    }
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                    this.$message.error(err.message || "兑换记录获取失败")
                })
        },
        refresh() {
            this.getListData()
        },
        handlePageSizeChange(size) {
            this.pageSize = size
            this.getListData()
        },
        handleCurrentPageChange(page) {
            this.currentPage = page
            this.getListData()
        },
        orderClose(order) {
            this.$confirm("确定关闭此次兑换？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                closePointExchangeOrder({
                    order_id: order.order_id
                }).then(res => {
                    if (res.code >= 0) {
                        this.$message.success("关闭成功")
                        this.getListData()
                    } else {
                        this.$message.warning(res.message || "关闭失败")
                    }
                })
            })
        },
        goPay(order) {
            if (!order.out_trade_no) {
                this.$message.warning("缺少支付交易单号")
                return
            }
            this.$router.push({
                path: "/pay",
                query: {
                    code: order.out_trade_no
                }
            })
        },
        copyDeliveryNo(deliveryNo) {
            if (!deliveryNo) return
            this.$copyText ? this.$copyText(deliveryNo) : this.copyByInput(deliveryNo)
            this.$message.success("物流单号已复制")
        },
        copyByInput(text) {
            const input = document.createElement("input")
            input.value = text
            document.body.appendChild(input)
            input.select()
            document.execCommand("copy")
            document.body.removeChild(input)
        },
        getExchangeImage(order) {
            if (order.exchange_image) return this.$img(order.exchange_image)
            if (order.type == 2) return this.$img("upload/uniapp/point/coupon.png")
            if (order.type == 3) return this.$img("upload/uniapp/point/hongbao.png")
            return this.defaultGoodsImage
        },
        hasLogisticsInfo(item) {
            if (!item) return false
            if (item.type == 4) return !!(item.express_company_name || item.delivery_no)
            return !!item.delivery_type_name
        },
        logisticsName(item) {
            if (item.type == 4) return item.express_company_name || "物流信息"
            return item.delivery_type_name || "物流信息"
        },
        statusName(status) {
            const statusMap = {
                0: "待支付",
                1: "已完成",
                "-1": "已关闭"
            }
            return statusMap[status] || "--"
        },
        statusTagType(status) {
            if (status == 0) return "warning"
            if (status == 1) return "success"
            if (status == -1) return "info"
            return ""
        },
        exchangeTypeName(type) {
            const typeMap = {
                1: "商品",
                2: "优惠券",
                3: "红包",
                4: "实物"
            }
            return typeMap[type] || "兑换"
        },
        money(value) {
            return Number(value || 0).toFixed(2)
        }
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 100%;
    position: relative;
}

.null-page {
    width: 100%;
    height: 730px;
    background-color: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
}

.point-exchange-order {
    border: 0;
}

.page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 14px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ebeef5;
    margin-top: 0;
}

.page-title {
    display: block;
    font-size: $ns-font-size-lg;
    font-weight: 600;
    line-height: 1.3;
}

.page-desc {
    display: block;
    margin-top: 2px;
    color: #909399;
    font-size: $ns-font-size-sm;
}

.summary-row {
    display: flex;
    gap: 12px;
    margin-bottom: 18px;
}

.summary-item {
    flex: 1;
    min-height: 72px;
    padding: 14px 16px;
    box-sizing: border-box;
    border: 1px solid #eeeeee;
    background: #fafafa;

    span {
        display: block;
        color: #606266;
        font-size: $ns-font-size-sm;
        line-height: 1.4;
    }

    strong {
        display: block;
        margin-top: 6px;
        color: $ns-text-color-black;
        font-size: 22px;
        line-height: 1.2;
    }
}

.record-table {
    width: 100%;
}

.goods-cell {
    display: flex;
    align-items: center;
    min-width: 0;
}

.goods-image {
    flex-shrink: 0;
    width: 58px;
    height: 58px;
    border: 1px solid #eeeeee;
    background: #f7f7f7;
}

.image-slot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #c0c4cc;
    font-size: 20px;
}

.goods-info {
    min-width: 0;
    margin-left: 12px;
}

.goods-name {
    color: $ns-text-color-black;
    font-weight: 600;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.goods-meta {
    display: flex;
    flex-direction: column;
    margin-top: 4px;
    color: #909399;
    font-size: $ns-font-size-sm;
    line-height: 1.5;
}

.point-value {
    color: $base-color;
    font-weight: 600;
}

.logistics-cell {
    color: #606266;
    line-height: 1.5;
}

.delivery-no {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #909399;
    font-size: $ns-font-size-sm;

    span {
        max-width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.muted {
    color: #c0c4cc;
}

.pager {
    margin-top: 18px;
}
</style>
